import { Container }from 'react-bootstrap';



interface ContentProps{
    children: React.ReactNode;
    additionalstyle?: string;
}

function MainContent({children, additionalstyle = ""}: ContentProps){
    return (
        <> 
            <Container fluid className={"block-main-content px-0 " + additionalstyle} >
                {children}
            </Container>
        </>
    )
}

export default MainContent;